import React from 'react';
import classNames from 'classnames';
import { Business } from '../../types/business';
import { useStyles } from './About.styles';
import EmailObfuscationWrapper from '../utils/EmailObfuscationWrapper';

const About = ({
  business,
  fullAbout,
  view,
}: {
  business: Business;
  fullAbout?: boolean;
  view: 'profile' | 'serp';
}) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(
        classes.profileAboutSection,
        classes.listingFont,
        view === 'serp' ? classes.profileAboutSectionHeight : undefined
      )}
    >
      <div className={classes.about} style={{ whiteSpace: 'pre-wrap' }}>
        {fullAbout ? (
          <EmailObfuscationWrapper>{business.about}</EmailObfuscationWrapper>
        ) : (
          <div className={classes.truncatedText}>
            <EmailObfuscationWrapper>{business.about}</EmailObfuscationWrapper>
          </div>
        )}
      </div>
    </div>
  );
};

export default About;
